<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12" style="padding:10px;display:none;">
          <div class="row">
            <div class="col-sm-3">
              <label>From</label>
              <input id="Txt_FromDate" type="Date" class="form-control" autocomplete="off">
            </div>
            <div class="col-sm-3">
              <label>To</label>
              <input id="Txt_ToDate" type="Date" class="form-control" autocomplete="off">
            </div>

            <div class="col-sm-3">
              <br>
              <span class="btn btn-outline-info waves-effect waves-light" title="Get" id="btnGet" (click)="GetDashboardDetails()">Search</span>
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="card card-danger">
            <div class="card-header">
              <div class="card-title"><h5>Due Articles</h5></div>

              <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                  <i class="fas fa-minus"></i>
                </button>
              </div>

            </div>
            <div class="card-body" style="display: block;">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Stage</th>
                    <th class="text-center">First Proof</th>
                    <th class="text-center">AU Correction</th>
                    <th class="text-center">Preview</th>
                    <th class="text-center">Revises</th>
                    <th class="text-center">Printer</th>
                    <th class="text-center">Final Web</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of DueArticleList">
                    <td>{{item.Stages}}</td>
                    <td><div class="alert {{item.CssName}} text-white  text-center p-t-0">{{item.FirstProof}}</div></td>
                    <td><div class="alert {{item.CssName}} text-white  text-center p-t-0">{{item.AUCorrection}}</div></td>
                    <td><div class="alert {{item.CssName}} text-white  text-center p-t-0">{{item.Preview}}</div></td>
                    <td><div class="alert {{item.CssName}} text-white  text-center p-t-0">{{item.Revises}}</div></td>
                    <td><div class="alert {{item.CssName}} text-white  text-center p-t-0">{{item.Printer}}</div></td>
                    <td><div class="alert {{item.CssName}} text-white  text-center p-t-0">{{item.FinalWeb}}</div></td>
                  </tr>

                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="card card-success">
              <div class="card-header">
                <div class="card-title"><h5>Delivery Report</h5></div>

                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <div class="card-body" style="display: block;">

                <highcharts-chart [Highcharts]="highchartsPie"
                                  [options]="chartOptions"
                                  style="width: 100%; height: 400px; display: block;">
                </highcharts-chart>

              </div>

            </div>
          </div>


          <div class="col-6">
            <div class="card card-primary">
              <div class="card-header">
                <div class="card-title"><h5>Ingestion & Delivery</h5></div>

                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <div class="card-body" style="display: block;">
                <highcharts-chart [Highcharts]="highchartsCol"
                                  [options]="chartOptionsCol"
                                  [oneToOne]="false"
                                  style="width: 100%; height: 400px; display: block;">
                </highcharts-chart>


              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
